export const ACCESS_CODE_QUERY_KEYS = {
  ACCESS_CONTEXT: 'access-context',
  REDEMPTION_STATUS: 'redemption-status',
} as const
